import { trackSearchFilterCategoryState } from "@javascript/helpers/searchFilterUtilities";

import Accordion, { AccordionContent, AccordionTrigger } from "@javascript/reactComponents/lds/accordion/Accordion";
import Chip from "@javascript/reactComponents/lds/chips/Chip";
import Divider from "@javascript/reactComponents/lds/Divider";

import FilterItem from "@javascript/reactComponents/lds/FilterItem";
import Heading from "@javascript/reactComponents/lds/typography/Heading";
import Icon from "@javascript/reactComponents/lds/Icon";

/**
 * React component that displays a list of search inputs (checkboxes) for "Clinical Trial Status"
 *
 * @params: none
 *
 */
const ClinicalTrialStatusSelector = createReactClass({
  mixins: [
    Reflux.connectFilter(
      FacetSearchStore,
      function(data) {
        return {
          clin_status: data.facets.clin_status,
          clinicalTrialStatuses: data.clinicalTrialStatuses,
        }
      }
    )
  ],
  /** Important: this.state is an empty object on the first render. Once the store connects, it then gets populated.*/
  getInitialState() {
    return {
      open: clinicalTrialStatuses.selected.length > 0,
    }
  },

  toggle() {
    trackSearchFilterCategoryState(!this.state.open, "trial_status");
    this.setState({ open: !this.state.open });
  },

  render() {
    const { clinicalTrialStatuses, clin_status } = this.state;
    const show = clin_status && clin_status.buckets && clin_status.buckets.length > 0;
    const { open } = this.state;

    if (!show) {
      return null;
    }

    const updateClinicalTrialStatusSelected = (value) => {
      const clinicalTrialStatusesSelected = [...this.state.clinicalTrialStatuses.selected];
      const selectedIndex = clinicalTrialStatusesSelected.indexOf(value);

      if (selectedIndex > -1) {
        // remove the clinical trial stage from the array... we no longer wish to represent it as checked
        clinicalTrialStatusesSelected.splice(selectedIndex, 1);
      } else {
        // add the clinical trial stage to the array... it should be checked now
        clinicalTrialStatusesSelected.push(value);
      }

      FacetSearchStoreActions.clinicalTrialStatusesUpdate(
        {selected: clinicalTrialStatusesSelected},
        {doSearch: true, triggerStateUpdate: true}
      );
    }

    const { display, selected } = clinicalTrialStatuses;

    const trailingAction = (
      <>
        <div className="flex-grow-1" />
        <Chip
          label=""
          selected={open}
          size="small"
          leadingIcon={`chevron-${open ? "up" : "down"}-centered`}
          variant={open ? "primary" : "secondary"}
        />
      </>
    );

    const statuses = Object.keys(display).map((key) => {
      const filterLabel = display[key];
      const isSelected = selected.indexOf(key) > -1;
      const leadingContent = <Icon name="checkbox" filled={isSelected} />
      const tooltip = `Filter events by trials with current status of ${filterLabel}`;

      return <FilterItem
        key={key}
        label={filterLabel}
        leadingContent={leadingContent}
        onLeadingContentClick={() => { updateClinicalTrialStatusSelected(key) }}
        selected={isSelected}
        tooltip={tooltip} />
    });

    return (
      <div id="trial_status_panel" ref="trial_status_panel">
        <Divider className="facet-search-section-divider" size="small" variant="secondary" />

        <Accordion open={open} className="filter_category status-accordian">
          <AccordionTrigger className="cursor-pointer" onClick={this.toggle}>
            <Heading
              id="trial_status_facets"
              leadingIcon="trial_status"
              size="h3"
              trailingAction={trailingAction}
              tooltip="Filter events based on whether they reference a trial currently registered with the state at clinicaltrials.gov."
            >
              {Zymewire.facet_search_filters.trial_status}
            </Heading>
          </AccordionTrigger>
          <AccordionContent className="filter_category_inner" gap="var(--filter-category-space-gap)">
            {statuses}
          </AccordionContent>
        </Accordion>
      </div>
    );
  }
});

window.ClinicalTrialStatusSelector = ClinicalTrialStatusSelector;
export default ClinicalTrialStatusSelector;
